import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const currentYear = new Date().getFullYear(); // Dinamikus év

  return (
      <Box
          component="footer"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mt: 1,
            pt: 3,
            backgroundColor: 'var(--sznodarkestblue)'
          }}
      >
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 4 }}>
          <Box className="footer-column" sx={{ minWidth: '200px' }}>
            <Typography variant="h6" className="footer-column-title">
              {t('Footer.Information')}
            </Typography>
            <ul>
              <li><Link to={`/${lang}/impresszum`}>{t('Footer.Imprint')}</Link></li>
              <li><Link to={`/${lang}/privacy-policy`}>{t('Footer.PrivacyPolicy')}</Link></li>
              <li><Link to={`/${lang}/latogatottsag`}>{t('Footer.Visits')}</Link></li>
              <li><Link to={`/${lang}/sutibeallitasok`} onClick={() => { localStorage.removeItem('cookie_consent'); }}>
                {t('Footer.CookieSettings')}
              </Link></li>
            </ul>
          </Box>

          <Box className="footer-column" sx={{ minWidth: '150px' }}>
            <Typography variant="h6" className="footer-column-title">
              {t('Footer.Guides')}
            </Typography>
            <ul>
              <li><Link to="/honismereti-terkep-utmutato">{t('Footer.MapGuide')}</Link></li>
              <li><Link to="/szekely-szotar-utmutato">{t('Footer.DictionaryGuide')}</Link></li>
              <li><Link to="/virtualis-akademia-utmutato">{t('Footer.AcademyGuide')}</Link></li>
              <li><Link to="/piacter-szabalyzat">{t('Footer.MarketGuide')}</Link></li>
            </ul>
          </Box>

          <Box className="footer-column" sx={{ minWidth: '150px' }}>
            <Typography variant="h6" className="footer-column-title">
              {t('Footer.Contact')}
            </Typography>
            <ul>
              <li><Link to="/hibajelentes">{t('Footer.ReportIssue')}</Link></li>
              <li><Link to="/irjon-nekunk">{t('Footer.WriteToUs')}</Link></li>
            </ul>
            <div className="socialDiv">
              <a
                  href="https://www.facebook.com/szekelynemzetonline/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialIcon"
              >
                <FacebookIcon />
              </a>
              <a
                  href="https://www.instagram.com/szekelynemzetonline"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialIcon"
              >
                <InstagramIcon />
              </a>
              <a
                  href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialIcon"
              >
                <LinkedInIcon />
              </a>
            </div>
          </Box>

          <Box className="footer-column" sx={{ minWidth: '200px' }}>
            <Typography variant="h6" className="footer-column-title">
              {t('Footer.OtherProjects')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2, alignItems: { xs: 'center', md: 'flex-start' }, px: 2 }}>
              <a
                  href="https://szotar.szno.ro"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <img src="/iszszt.png" alt="Székely Szótár" style={{ width: '40px', height: 'auto' }} />
                <Typography variant="body2" sx={{ color: '#c0c0c0', fontSize: 'small' }}>szotar.szno.ro</Typography>
              </a>
              <a
                  href="https://szft.ro"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <img src="/szflogouj.png" alt="Székelyföldi Tudástár" style={{ width: '40px', height: 'auto' }} />
                <Typography variant="body2" sx={{ color: '#c0c0c0', fontSize: 'small' }}>szft.ro</Typography>
              </a>
            </Box>
          </Box>
        </Box>

        <Box className="footer-line" sx={{ mt: 2, mb: 1 }}>
          <Typography variant="body2" sx={{ color: 'var(--lightTitanium)' }}>
            © 2025–{currentYear} {t('Footer.AllRightsReserved')}
          </Typography>
        </Box>
      </Box>
  );
};

export default Footer;
